import { setStore, getStore } from '@/until/utils'

export default {
    cart_count: state => state.cart_count , //进货单数量
}


// WEBPACK FOOTER //
// ./src/store/getter.js